export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8745.97b0ac2d.jpg";